export const VIN_REQUIRED_MESSAGE =
  "Please enter a vehicle identification number to continue\n";

export const VIN_VALIDATION_MESSAGE =
  "A valid vehicle identification number is required. Is it a valid VIN? Valid vehicle identification numbers:\n" +
  "<ul> " +
  "<li>Have exactly 17 characters</li>" +
  "<li>Come from a vehicle manufactured since 1981</li>" +
  "<li>Do not contain letters I, O, or Q</li>" +
  "</ul>";

export const VIN_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/;

const VIN_WEIGHTS = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];

const VIN_TRANSLITERATION = {
  A: 1,
  B: 2,
  C: 3,
  D: 4,
  E: 5,
  F: 6,
  G: 7,
  H: 8,
  J: 1,
  K: 2,
  L: 3,
  M: 4,
  N: 5,
  P: 7,
  R: 9,
  S: 2,
  T: 3,
  U: 4,
  V: 5,
  W: 6,
  X: 7,
  Y: 8,
  Z: 9,
};

export const normalizeVin = (vin = "") => vin.trim().toUpperCase();

export const isValidVinFormat = (vin = "") =>
  VIN_REGEX.test(normalizeVin(vin));

export const hasValidVinChecksum = (vin = "") => {
  const normalizedVin = normalizeVin(vin);

  if (!VIN_REGEX.test(normalizedVin)) {
    return false;
  }

  const total = normalizedVin.split("").reduce((sum, char, index) => {
    const value = Number.isNaN(Number(char))
      ? VIN_TRANSLITERATION[char]
      : Number(char);

    return sum + value * VIN_WEIGHTS[index];
  }, 0);

  const remainder = total % 11;
  const expectedCheckDigit = remainder === 10 ? "X" : String(remainder);

  return normalizedVin[8] === expectedCheckDigit;
};

export const isValidVin = (vin = "") =>
  isValidVinFormat(vin) && hasValidVinChecksum(vin);